export interface GlassImpact {
  impactsType: ImpactType;
  size: ImpactSize;
  inVisionField: boolean;
  atOuterEdge: boolean;
}

export enum ImpactSizeEnum {
  bigger2cm = 'bigger2cm',
  smaller2cm = 'smaller2cm',
}
export type ImpactSize = `${ImpactSizeEnum}`;

export enum ImpactTypeEnum {
  oneImpact = '1impact',
  twoImpactsLess = '2impactsLess',
  twoOrThreeImpacts = '2or3impacts',
  threeImpactsLess = '3impactsLess',
  threeIimpactsMore = '3impactsMore',
  more3impactsOrCrack = 'more3impactsOrCrack',
  crack = 'crack',
}
export type ImpactType = `${ImpactTypeEnum}`;
